(function () {
  'use strict';

  angular.module('app').component('bookingGuestList', bookingGuestList());

  function bookingGuestList() {
    return {
      bindings: {
        booking: '=',
        guests: '=',
        onBookingGuestSaved: '&',
      },
      controller: BookingGuestListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-guests/booking-guest-list/booking-guest-list.component.html',
    };
  }

  BookingGuestListCtrl.$inject = [
    'UtilService',
    'GuestService',
    'BookingItemService',
    'ModalWindowConfirmService',
  ];

  function BookingGuestListCtrl(
    UtilService,
    GuestService,
    BookingItemService,
    ModalWindowConfirmService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // public methods
    // -----------------------
    vm.addBookingGuest = function () {
      let successCallback = function (guestObj) {
        vm.guests.push(guestObj);
        vm.UtilService.itemListChanged(guestObj.id);

        checkDefaultBookingGuest();

        vm.onBookingGuestSaved({ guestsObj: vm.guests });
      };

      GuestService.openBookingGuestDetailModal({}, vm.booking, 'create', successCallback);
    };

    vm.showBookingGuest = function (guest, mode) {
      let successCallback = function () {
        vm.onBookingGuestSaved({ guestsObj: vm.guests });
      };

      GuestService.openBookingGuestDetailModal(guest, vm.booking, mode, successCallback);
    };

    vm.changeBookingGuestDefault = function (guest) {
      let successCallback = function () {
        vm.guests.forEach(function (item) {
          item.is_default = item.id === guest.id;
        });

        checkDefaultBookingGuest();
      };

      GuestService.changeBookingGuestDefault(guest, vm.booking.id, successCallback);
    };

    vm.deleteBookingGuest = function (guest, index) {
      if (!hasRelatedItems(guest)) {
        let successCallback = function () {
          vm.guests.splice(index, 1);
        };

        GuestService.deleteBookingGuest(guest, vm.booking.id, successCallback);
      } else {
        let modalParams = {
          title: 'DELETE_ITEMS',
          body: 'GUEST_HAS_BEEN_ASSIGNED',
          mode: 'danger',
          closeButtonLabel: 'ACCEPT',
        };

        ModalWindowConfirmService.open(modalParams);
      }
    };

    vm.openAddGuestToBookingItem = function (guest) {
      let successCallback = function (response) {
        vm.booking = response;
      };

      GuestService.openAddGuestToBookingItem(guest, vm.booking, successCallback);
    };

    vm.openCheckInGuestToItem = function (guest) {
      let successCallback = function (response) {
        vm.booking = response;
      };

      GuestService.openCheckInGuestToItem(guest, vm.booking, successCallback);
    };

    vm.addAllGuestToAllItems = function () {
      let successCallback = (bookingItems, guests) => {
        vm.sendingForm = true;
        BookingItemService.saveAllGuestToItems(bookingItems, guests).then(function (data) {
          if (data.status) vm.booking = data.response;

          vm.sendingForm = false;
        });
      };

      vm.booking.booking_items.forEach((bookingItem) => {
        vm.booking.guests.forEach((guest) => {
          if (bookingItem.based_on_service_items) {
            bookingItem.booking_item_service_items.forEach((serviceItem) => {
              let isGuestAdded = serviceItem.guest_ids.includes(guest.id);
              serviceItem.guests = serviceItem.guests || [];

              if (!isGuestAdded) serviceItem.guest_ids.push(guest.id);
            });
          } else {
            let isGuestAdded = bookingItem.guest_ids.includes(guest.id);
            bookingItem.guests = bookingItem.guests || [];

            if (!isGuestAdded) bookingItem.guest_ids.push(guest.id);
          }
        });
      });

      successCallback(vm.booking.booking_items, vm.booking.guests);
    };

    vm.isAddedToAllItems = function (bookingItems, guest) {
      let totalItems = 0;

      bookingItems.forEach((item) => {
        if (item.based_on_service_items) {
          totalItems += item.booking_item_service_items.length;
        } else {
          totalItems++;
        }
      });

      let totalItemsSelected =
        guest.booking_item_ids.length + guest.booking_item_service_item_ids.length;

      if (totalItemsSelected === totalItems && totalItemsSelected > 0) {
        return 'YES';
      } else if (totalItemsSelected < totalItems && totalItemsSelected > 0) {
        return 'PARTIALLY';
      }

      return 'NO';
    };

    vm.$onInit = function () {
      checkDefaultBookingGuest();
    };

    // private methods
    // -----------------------
    function hasRelatedItems(guest) {
      return guest.booking_item_ids.length !== 0 && guest.booking_item_service_item_ids !== 0;
    }

    function checkDefaultBookingGuest() {
      vm.errorDefaultBookingGuest = !vm.guests.find((guest) => guest.is_default);
    }
  }
})();
